<template>
  <section>
    <div class="action-buttons">
      <div
        class="button-add-campaign"
        v-if="!modifiedRows.length"
      >
        <button
          class="button is-success is-medium"
          id="clear"
          @click="$parent.isComponentModalActive = true"
        >
          <span><i class="fal fa-plus-circle"></i> Ajouter un Thème</span>
        </button>
      </div>

      <div class="action-button">
        <button
          v-if="checkedRows.length"
          class="button field is-danger is-medium"
          id="clear"
          @click="deleteChecked"
          :disabled="!checkedRows.length"
        >
          <span>Supprimer</span>
        </button>
      </div>

      <div class="action-button">
        <button
          v-if="modifiedRows.length"
          class="button field is-green is-medium"
          id="clear"
          @click="validateModifications"
          :disabled="!modifiedRows.length"
        >
          <span><i class="fal fa-check"></i> Valider les modifications</span>
        </button>
      </div>

      <div class="action-button">
        <button
          v-if="modifiedRows.length"
          class="button field is-danger is-medium"
          id="clear"
          @click="cancelModifications"
          :disabled="!modifiedRows.length"
        >
          <span><i class="fal fa-times"></i> Annuler les modifications</span>
        </button>
      </div>
    </div>

    <b-modal
      :active.sync="$parent.isComponentModalActive"
      has-modal-card
    >
      <form action="add-weezy">
        <div
          class="modal-card"
          style="width: 450px;"
        >
          <header
            class="modal-card-head"
            style="text-align: center"
          >
            <p class="modal-card-title">Ajouter un Thème</p>
          </header>
          <section class="modal-card-body">
            <div class="modal-line">
              <b-field
                class="b-modal-input-field"
                label="Nom du Thème :"
                required
              >
                <b-input
                  v-model="formName"
                  class="b-modal-text-input"
                  type="text"
                  placeholder="Entrer un Nom"
                ></b-input>
              </b-field>
            </div>

            <div class="modal-line">
              <b-field
                class="b-modal-select-field"
                label="Animation Vente :"
                required
              >
                <b-select
                  placeholder="Choisir l'animation"
                  v-model="formAnimSale"
                  :required="true"
                >
                  <option
                    value=""
                    disabled
                  >Choisir l'Animation</option>
                  <option value="chenillard">Chenillard</option>
                  <option value="random">Aléatoire</option>
                  <option value="flash">Flash</option>
                </b-select>
              </b-field>

              <b-field
                class="b-modal-select-field"
                label="Animation Objectif :"
                required
              >
                <b-select
                  placeholder="Choisir l'animation"
                  v-model="formAnimWin"
                  :required="true"
                >
                  <option
                    value=""
                    disabled
                  >Choisir l'Animation</option>
                  <option value="chenillard">Chenillard</option>
                  <option value="random">Aléatoire</option>
                  <option value="flash">Flash</option>
                </b-select>
              </b-field>
            </div>

            <div class="modal-line">
              <b-field
                class="b-modal-select-field"
                label="Couleur LED Primaire :"
                required
              >
                <custom-select
                  :options="colors"
                  @change="selectColor1($event)"
                />
              </b-field>
              <b-field
                class="b-modal-select-field"
                label="Couleur LED Secondaire :"
                required
              >
                <custom-select
                  :options="colors"
                  @change="selectColor2($event)"
                />
              </b-field>
            </div>
          </section>
          <footer
            class="modal-card-foot"
            style="justify-content: space-evenly"
          >
            <button
              class="button is-danger"
              type="button"
              @click="dismissForm"
            ><span><i class="fal fa-times"></i> Annuler</span></button>
            <button
              class="button is-success"
              type="button"
              @click="submitFormData"
            ><span><i class="fal fa-check"></i> Ajouter</span></button>
          </footer>
        </div>
      </form>
    </b-modal>

    <b-modal
      :active.sync="isModifyColorsModalActive"
      has-modal-card
    >
      <form action="modify-colors">
        <div
          class="modal-card"
          style="width: 550px;"
        >
          <header
            class="modal-card-head"
            style="text-align: center"
          >
            <p class="modal-card-title">Modifier les Couleurs LED</p>
          </header>
          <section class="modal-card-body">
            <div class="modal-line">
              <b-field
                class="b-modal-select-field"
                label="Couleur LED Primaire :"
                required
              >
                <custom-select
                  :options="colors"
                  @change="selectColor1($event)"
                  :default="this.formColor1"
                />
              </b-field>
              <b-field
                class="b-modal-select-field"
                label="Couleur LED Secondaire :"
                required
              >
                <custom-select
                  :options="colors"
                  @change="selectColor2($event)"
                  :default="this.formColor2"
                />
              </b-field>
            </div>
          </section>
          <footer
            class="modal-card-foot"
            style="justify-content: space-evenly"
          >
            <button
              class="button is-danger"
              type="button"
              @click="dismissForm"
            ><span><i class="fal fa-times"></i> Annuler</span></button>
            <button
              class="button is-success"
              type="button"
              @click="submitFormData"
            ><span><i class="fal fa-check"></i> Valider</span></button>
          </footer>
        </div>
      </form>
    </b-modal>

    <b-modal
      :active.sync="$parent.isDeleteConfirmationModalActive"
      has-modal-card
    >
      <form action="add-weezy">
        <div
          class="modal-card"
          style="width: 480px;"
        >
          <header
            class="modal-card-head"
            style="text-align: center"
          >
            <p class="modal-card-title">Confirmer la suppression ?</p>
          </header>
          <footer
            class="modal-card-foot"
            style="justify-content: space-evenly"
          >
            <button
              class="button is-danger"
              type="button"
              @click="dismissForm"
            ><span><i class="fal fa-times"></i> Annuler</span></button>
            <button
              class="button is-success"
              type="button"
              @click="confirmDelete"
            ><span><i class="fal fa-check"></i> Confirmer</span></button>
          </footer>
        </div>
      </form>
    </b-modal>

    <b-table
      class="b-table"
      :data="myData"
      :striped="true"
      :hoverable="true"
      :loading="isLoading"
      :checked-rows.sync="checkedRows"
      :checkable="checkable"
      :mobile-cards="false"
    >
      <template
        slot-scope="props"
        slot="header"
      >
        <b-tooltip
          :active="!!props.column.meta"
          :label="props.column.meta"
        >
          {{ props.column.label }}
        </b-tooltip>
      </template>

      <template slot-scope="props">
        <b-table-column
          class="b-table-column"
          field="name"
          label="Nom"
          meta="Nom du thème"
          :centered="true"
          :sortable="true"
          width="150"
        >
          <span class="tag is-primary is-medium">
            <input
              class="b-name-input"
              v-model="props.row.name"
              @input="toggleModified(props.row)"
              placeholder="Entrer un nom"
            >
          </span>
        </b-table-column>

        <b-table-column
          field="color_1"
          label="Couleur LED Primaire"
          meta="Couleur principale de la guirlande LED"
          :centered="false"
        >
          <div
            class="hidden"
            style="display : inline;"
          >
            <span
              class="tag"
              :style="getColor(props.row.color_1)"
              @click="showDetail(props.row)"
            ></span>
            <span>
              {{ getColorName(props.row.color_1.hex == undefined ? props.row.color_1.toLowerCase() : props.row.color_1.hex.toLowerCase()) }}
              <a
                class="ml2"
                @click="showDetail(props.row)"
              >
                <i class="fas fa-pen black"></i>
              </a>
            </span>
          </div>
        </b-table-column>

        <b-table-column
          meta="Couleur secondaire de la guirlande LED"
          field="color_2"
          label="Couleur LED Secondaire"
          :centered="false"
        >
          <span
            class="tag"
            :style="getColor(props.row.color_2)"
            @click="showDetail(props.row)"
          >
          </span>
          <span>
            {{ getColorName(props.row.color_2.hex == undefined ? props.row.color_2.toLowerCase() : props.row.color_2.hex.toLowerCase()) }}
            <a
              class="ml2"
              @click="showDetail(props.row)"
            >
              <i class="fas fa-pen black"></i>
            </a>
          </span>
        </b-table-column>

        <b-table-column
          meta="Animation sur les LED lorsqu'une vente est déclarée"
          class="b-table-column"
          field="anim-sale"
          label="Animation Vente"
          :centered="true"
          :sortable="true"
        >
          <b-select
            placeholder="Choisir l'animation"
            v-model="props.row.anim_sale"
            @input="toggleModified(props.row)"
            :required="true"
          >
            <option
              value=""
              disabled
            >Choisir l'animation</option>
            <option value="chenillard">Chenillard</option>
            <option value="random">Aléatoire</option>
            <option value="flash">Flash</option>
          </b-select>
        </b-table-column>

        <b-table-column
          meta="Animation sur les LED lorsque l'objectif de ventes est atteint"
          class="b-table-column"
          field="anim-win"
          label="Animation Win"
          :centered="true"
          :sortable="true"
        >
          <b-select
            placeholder="Choisir l'animation"
            v-model="props.row.anim_win"
            @input="toggleModified(props.row)"
            :required="true"
          >
            <option
              value=""
              disabled
            >Choisir l'animation</option>
            <option value="chenillard">Chenillard</option>
            <option value="random">Aléatoire</option>
            <option value="flash">Flash</option>
          </b-select>
        </b-table-column>
      </template>

      <template slot="empty">
        <section class="section">
          <div
            v-if="!isLoading"
            class="content has-text-grey has-text-:centered"
          >
            <p>Pas de Thèmes</p>
          </div>
        </section>
      </template>
    </b-table>
  </section>
</template>

<script>
import { Chrome } from "vue-color";
import { Slider } from "vue-color";
import customSelect from "@/components/customSelect";
import _ from "lodash";

export default {
  name: "ThemesTable",
  props: ["themes", "checkable"],
  components: {
    "chrome-picker": Chrome,
    "slider-picker": Slider,
    "custom-select": customSelect
  },
  data: () => {
    return {
      isLoading: true,
      checkedRows: [],
      modifiedRows: [],
      detailed: [],
      myData: [],
      storedThemes: [],
      formColor1: "#2aa3d6",
      formColor2: "#2aa3d6",
      formName: "",
      formAnimSale: "",
      formAnimWin: "",
      isModifyColorsModalActive: false,
      colorModifiedThemeId: "",
      colors: [
        { text: "Bleu Armatis", value: "#2aa3d6" },
        { text: "Vert Clair Armatis", value: "#b2cf16" },
        { text: "Vert Armatis", value: "#1ba336" },
        { text: "Violet Armatis", value: "#8d1778" },
        { text: "Rouge", value: "#FF0000" },
        { text: "Vert", value: "#00FF00" },
        { text: "Bleu", value: "#0000FF" },
        { text: "Jaune", value: "#FFFF00" },
        { text: "Rose", value: "#FF00FF" },
        { text: "Orange", value: "#FF9000" },
        { text: "Cyan", value: "#00FFFF" }
      ]
    };
  },
  watch: {
    themes: function(newVal, oldVal) {
      // watch it
      this.myData = this.themes;
      this.storedThemes = JSON.parse(JSON.stringify(this.themes));
      this.isLoading = false;
    }
  },
  methods: {
    resetMyData() {
      this.myData = [
        {
          name: "",
          campaign_id: "",
          supervisor_id: "",
          is_active: false,
          id: "",
          color_1: "#000000",
          color_2: "#000000"
        }
      ];
    },
    deleteChecked() {
      this.$parent.isDeleteConfirmationModalActive = true;
    },
    confirmDelete() {
      this.$parent.deleteCheckedRows(this.checkedRows);
      this.checkedRows = [];
    },

    debounceModif: _.debounce(async function(e) {
      this.$parent.modifyRows(e);
    }, 500),

    toggleModified(raaw) {
      this.debounceModif([raaw]);

      // var modified = false;
      // this.modifiedRows.push(raaw);
      // for (var j = 0; j < this.modifiedRows.length; j++) {
      //   var row = this.modifiedRows[j];
      //   for (var i = 0; i < this.storedThemes.length; i++) {
      //     var theme = this.storedThemes[i];
      //     if (theme.id == row.id) {
      //       if (
      //         !(
      //           theme.name == row.name &&
      //           theme.color_1 == row.color_1 &&
      //           theme.color_2 == row.color_2 &&
      //           theme.anim_sale == row.anim_sale &&
      //           theme.anim_win == row.anim_win
      //         )
      //       ) {
      //         modified = true;
      //       }
      //     }
      //   }
      //   if (!modified) {
      //     this.modifiedRows = [];
      //   }
      // }
    },
    validateModifications() {
      this.$parent.modifyRows(this.modifiedRows);

      setTimeout(() => {
        this.modifiedRows = [];
        this.checkedRows = [];
        this.storedThemes = JSON.parse(JSON.stringify(this.themes));
      }, 100);
    },
    cancelModifications() {
      this.$parent.getThemes();

      setTimeout(() => {
        this.modifiedRows = [];
        this.checkedRows = [];
        this.storedThemes = JSON.parse(JSON.stringify(this.themes));
      }, 100);
    },
    submitFormData() {
      if (this.isModifyColorsModalActive) {
        this.$parent.modifyRow({
          anim_sale: this.formAnimSale,
          anim_win: this.formAnimWin,
          color_1: this.formColor1,
          color_2: this.formColor2,
          name: this.formName,
          id: this.colorModifiedThemeId
        });

        setTimeout(() => {
          this.storedThemes = JSON.parse(JSON.stringify(this.themes));
          this.modifiedRows = [];
          this.checkedRows = [];
          this.resetMyData;
          this.dismissForm();
        }, 70);
      } else {
        if (
          this.formColor1 == "" ||
          this.formColor2 == "" ||
          this.formName == "" ||
          this.formAnimSale == "" ||
          this.formAnimWin == ""
        ) {
          this.$parent.errorToast("Merci de remplir tous les champs");
        } else {
          this.$parent.addNewRow({
            anim_sale: this.formAnimSale,
            anim_win: this.formAnimWin,
            color_1: this.formColor1,
            color_2: this.formColor2,
            name: this.formName
          });
          setTimeout(() => {
            this.storedThemes = JSON.parse(JSON.stringify(this.themes));
            this.modifiedRows = [];
            this.checkedRows = [];
            this.resetFormData();
          }, 70);
        }
      }
    },
    dismissForm() {
      this.$parent.isDeleteConfirmationModalActive = false;
      this.isModifyColorsModalActive = false;
      this.$parent.isComponentModalActive = false;
      this.resetFormData();
    },
    resetFormData() {
      (this.formAnimWin = ""),
        (this.formName = ""),
        (this.formColor1 = "#2aa3d6"),
        (this.formColor2 = "#2aa3d6"),
        (this.formAnimSale = ""),
        (this.colorModifiedThemeId = "");
    },
    getColor(value) {
      value = value.hex == undefined ? value : value.hex;
      return (
        "background-color:" +
        value +
        "; color: #FFFFFF; vertical-align: middle; height: 13px;"
      );
    },
    getColorName(color) {
      for (var i = 0; i < this.colors.length; i++) {
        if (this.colors[i].value.toLowerCase() == color.toLowerCase()) {
          return this.colors[i].text;
        }
      }
    },
    showDetail(row) {
      this.isModifyColorsModalActive = true;
      this.formColor1 = row.color_1;
      this.formColor2 = row.color_2;
      this.colorModifiedThemeId = row.id;
      this.formAnimWin = row.anim_win;
      this.formName = row.name;
      this.formAnimSale = row.anim_sale;
    },
    selectColor1(color) {
      this.formColor1 = color;
    },
    selectColor2(color) {
      this.formColor2 = color;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (max-width: 768px) {
  .action-buttons,
  .action-button {
    float: unset;
  }

  .b-table {
    margin-top: 2em;
  }
}

.b-table {
  width: auto;
}

.b-name-input {
  width: 150px;
  text-align: center;
  border-color: transparent !important;
  background-color: transparent;
  color: #fff;
  outline: 0px !important;
  font-size: 1em;
  display: inline-block;
}

.b-anim-input {
  width: 100px;
  text-align: center;
  border-color: transparent !important;
  background-color: transparent;
  color: #fff;
  outline: 0px !important;
  font-size: 1em;
  display: inline-block;
}

.b-color-input {
  display: none;
}

.b-table-column {
  vertical-align: middle;
}
.vue-color {
  width: 75%;
}

.action-button {
  float: right;
  padding-right: 10px;
}

.modal-card-body {
  overflow: visible;
  z-index: 1;
}

.modal-card {
  overflow: visible;
}

.modal-line {
  display: flex;
  justify-content: space-between;
}

.modal-input-field {
  width: 175px;
  padding-left: 0px;
}

.modal-vue-color {
  width: 225px;
}

.b-modal-select-field {
  width: 200px;
}
</style>